"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Time {
    static compactDuration(seconds) {
        if (seconds < 60) {
            return { value: Math.max(0, Math.floor(seconds)), unit: "seconds" };
        }
        if (seconds < 3600) {
            return { value: Math.ceil(seconds / 60), unit: "minutes" };
        }
        if (seconds < 86400) {
            return { value: Math.ceil(seconds / 3600), unit: "hours" };
        }
        return { value: Math.ceil(seconds / 86400), unit: "days" };
    }
}
exports.default = Time;
